<!--
基于element-china-area-dat 封装城市级联下拉
-->
<template>
  <div>
    <el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange">
    </el-cascader>
  </div>
</template>
<script>
import { regionData, CodeToText } from 'element-china-area-data';
export default {
  data() {
    return {
      options: regionData
    };
  },
  props: {
    selectedOptions: Array
  },
  methods: {
    handleChange(value) {
      var ctt = CodeToText[value[0]] + CodeToText[value[1]];
      this.$emit('update:selectedOptions', value);
      console.log(ctt);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/common/component/cityPicker.vue